import { render, staticRenderFns } from "./Scrap.vue?vue&type=template&id=4473cced"
import script from "./Scrap.vue?vue&type=script&lang=js"
export * from "./Scrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports